// extracted by mini-css-extract-plugin
export default {"compliance":"Compliance_compliance__a8ktx","compliance__content":"Compliance_compliance__content__UWx0s","compliance__menu":"Compliance_compliance__menu__oLQB-"};